if (!customElements.get("variant-picker")) {
  class VariantPicker extends HTMLElement {
    constructor() {
      super();
    }

    get selectedOptionValues() {
      const options = this.querySelectorAll(
        "select, .variant-picker__field input[type='radio']"
      );
      const selectedValues = new Map();

      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;

        if (field.tagName.toLowerCase() === "select") {
          const selectedOption = Array.from(field.options).find(
            (opt) => opt.selected && !opt.disabled
          );
          if (selectedOption) {
            selectedValues.set(fieldName, selectedOption.dataset.optionValueId);
          }
          
        } else if (
          field.tagName.toLowerCase() === "input" &&
          field.type === "radio"
        ) {
          const checkedInput = field.checked ? field : null;
          const isInvalid =
            checkedInput &&
            (checkedInput.disabled ||
              checkedInput.classList.contains("disabled"));
          if (checkedInput && !isInvalid) {
            selectedValues.set(fieldName, checkedInput.dataset.optionValueId);
          }
        }
      });

      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;

        if (!selectedValues.has(fieldName)) {
          if (field.tagName.toLowerCase() === "select") {
            const firstValidOption = Array.from(field.options).find(
              (opt) => !opt.disabled
            );
            if (firstValidOption) {
              selectedValues.set(
                fieldName,
                firstValidOption.dataset.optionValueId
              );
            }
          } else if (
            field.tagName.toLowerCase() === "input" &&
            field.type === "radio"
          ) {
            const radiosInGroup = Array.from(
              this.querySelectorAll(
                ".variant-picker__field input[type='radio']"
              )
            ).filter(
              (inp) => (inp.name || inp.dataset.fieldName) === fieldName
            );
            const firstValidRadio = radiosInGroup.find(
              (r) => !r.disabled && !r.classList.contains("disabled")
            );
            if (firstValidRadio) {
              selectedValues.set(
                fieldName,
                firstValidRadio.dataset.optionValueId
              );
            }
          }
        }
      });

      const result = [];
      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;
        if (selectedValues.has(fieldName)) {
          const optionValueId = selectedValues.get(fieldName);
          if (optionValueId && !result.includes(optionValueId)) {
            result.push(optionValueId);
          }
        }
      });
      return result;
    }

    getInputForEventTarget(target) {
      return target.tagName === "SELECT" ? target.selectedOptions[0] : target;
    }

    getSelectedValuesMap() {
      const options = this.querySelectorAll(
        "select, .variant-picker__field input[type='radio']"
      );
      const selectedValues = new Map();
      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;
        if (field.tagName.toLowerCase() === "select") {
          const selectedOption = Array.from(field.options).find(
            (opt) => opt.selected && !opt.disabled
          );
          if (selectedOption) {
            selectedValues.set(fieldName, selectedOption.dataset.optionValueId);
          }
        } else if (
          field.tagName.toLowerCase() === "input" &&
          field.type === "radio"
        ) {
          const checkedInput = field.checked ? field : null;
          const isInvalid =
            checkedInput &&
            (checkedInput.disabled ||
              checkedInput.classList.contains("disabled"));
          if (checkedInput && !isInvalid) {
            selectedValues.set(fieldName, checkedInput.dataset.optionValueId);
          }
        }
      });
      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;
        if (!selectedValues.has(fieldName)) {
          if (field.tagName.toLowerCase() === "select") {
            const firstValidOption = Array.from(field.options).find(
              (opt) => !opt.disabled
            );
            if (firstValidOption) {
              selectedValues.set(
                fieldName,
                firstValidOption.dataset.optionValueId
              );
            }
          } else if (
            field.tagName.toLowerCase() === "input" &&
            field.type === "radio"
          ) {
            const radiosInGroup = Array.from(
              this.querySelectorAll(
                ".variant-picker__field input[type='radio']"
              )
            ).filter(
              (inp) => (inp.name || inp.dataset.fieldName) === fieldName
            );
            const firstValidRadio = radiosInGroup.find(
              (r) => !r.disabled && !r.classList.contains("disabled")
            );
            if (firstValidRadio) {
              selectedValues.set(
                fieldName,
                firstValidRadio.dataset.optionValueId
              );
            }
          }
        }
      });
      return selectedValues;
    }

    getFirstValidValuesMap() {
      const options = this.querySelectorAll(
        "select, .variant-picker__field input[type='radio']"
      );
      const selectedValues = new Map();
      options.forEach((field) => {
        const fieldName = field.name || field.dataset.fieldName;
        if (field.tagName.toLowerCase() === "select") {
          const firstValidOption = Array.from(field.options).find(
            (opt) => !opt.disabled
          );
          if (firstValidOption) {
            selectedValues.set(
              fieldName,
              firstValidOption.dataset.optionValueId
            );
          }
        } else if (
          field.tagName.toLowerCase() === "input" &&
          field.type === "radio"
        ) {
          const radiosInGroup = Array.from(
            this.querySelectorAll(
              ".variant-picker__field input[type='radio']"
            )
          ).filter(
            (inp) => (inp.name || inp.dataset.fieldName) === fieldName
          );
          const firstValidRadio = radiosInGroup.find(
            (r) => !r.disabled && !r.classList.contains("disabled")
          );
          if (firstValidRadio) {
            selectedValues.set(
              fieldName,
              firstValidRadio.dataset.optionValueId
            );
          }
        }
      });
      return selectedValues;
    }

    isCurrentVariantInvalid() {
      const script = this.querySelector("[data-selected-variant]");
      if (!script?.textContent?.trim()) return true;
      let variant;
      try {
        variant = JSON.parse(script.textContent);
      } catch (e) {
        return true;
      }
      if (!variant) return true;
      const noPrice =
        variant.price == null || Number(variant.price) === 0;
      const noImage =
        !variant.featured_image && !variant.featured_media;
      return noPrice || noImage;
    }

    syncToFirstValidAndNotify() {
      const forceFirstValid = this.isCurrentVariantInvalid();
      const map = forceFirstValid
        ? this.getFirstValidValuesMap()
        : this.getSelectedValuesMap();
      let eventTarget = null;
      let didChange = false;
      const options = this.querySelectorAll(
        "select, .variant-picker__field input[type='radio']"
      );
      const seen = new Set();
      map.forEach((optionValueId, fieldName) => {
        if (!optionValueId || seen.has(fieldName)) return;
        seen.add(fieldName);
        for (const field of options) {
          const name = field.name || field.dataset.fieldName;
          if (name !== fieldName) continue;
          if (field.tagName.toLowerCase() === "select") {
            const opt = Array.from(field.options).find(
              (o) => String(o.dataset.optionValueId) === String(optionValueId)
            );
            if (opt) {
              if (!opt.selected) {
                opt.selected = true;
                didChange = true;
              }
              if (!eventTarget) eventTarget = opt;
            }
            break;
          }
          if (
            field.tagName.toLowerCase() === "input" &&
            field.type === "radio"
          ) {
            if (String(field.dataset.optionValueId) === String(optionValueId)) {
              if (!field.checked) {
                field.checked = true;
                didChange = true;
              }
              if (!eventTarget) eventTarget = field;
              break;
            }
          }
        }
      });
      const shouldNotify =
        (didChange || forceFirstValid) &&
        eventTarget &&
        typeof window.FoxThemeEvents !== "undefined" &&
        typeof PUB_SUB_EVENTS !== "undefined";
      if (shouldNotify) {
        window.FoxThemeEvents.emit(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          {
            data: {
              event: { target: eventTarget },
              target: eventTarget,
              selectedOptionValues: this.selectedOptionValues,
            },
          }
        );
      }
    }

    connectedCallback() {
      this.addEventListener("change", (event) => {
        document.querySelectorAll('.f-product-form__buttons .f-product-form__submit').forEach((each)=>{
          each.style.opacity = '.5';
          each.style.pointerEvents = 'none'
      })
        const target = this.getInputForEventTarget(event.target);
        window.FoxThemeEvents.emit(PUB_SUB_EVENTS.optionValueSelectionChange, {
          data: {
            event,
            target,
            selectedOptionValues: this.selectedOptionValues,
          },
        });
      });
      this.correctInvalidVariantFromURL();
      const runSync = () => this.syncToFirstValidAndNotify();
      requestAnimationFrame(runSync);
      setTimeout(runSync, 1000);
    }
    correctInvalidVariantFromURL() {
      const urlParams = new URLSearchParams(window.location.search);
      const variantIdFromURL = urlParams.get("variant");
    
      if (!variantIdFromURL) return;
    
      const variantInput = document.querySelector(
        `input[data-variantid="${variantIdFromURL}"]`
      );
    
      if (!variantInput) return;
    
      const hasInventory =
        parseInt(variantInput.dataset.variantavailable || 0) > 0;
    
      const isDisabled =
        variantInput.classList.contains("disabled");
    
      // ✅ If valid → do nothing
      if (hasInventory && !isDisabled) return;
    
      // ❌ If invalid → remove variant param
      urlParams.delete("variant");
    
      const newUrl =
        window.location.pathname +
        (urlParams.toString() ? "?" + urlParams.toString() : "");
    
      window.location.replace(newUrl);
    }
  }
  customElements.define("variant-picker", VariantPicker);
}
